import { useRedirectAfterAuth } from '@components/Router/hooks/useRedirectAfterAuth'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useAuth } from '@/hooks'
import { selectIsLoading } from '@/store'
import { GuestGate } from './GuestGate'

export const AuthenticatedWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { authenticated } = useAuth()
  const loading = useSelector(selectIsLoading('authentication'))

  useRedirectAfterAuth()

  if (loading) {
    return null
  }

  if (!authenticated) {
    return <GuestGate />
  }

  return <>{children}</>
}
